import axios from 'axios';
import { toast } from 'react-toastify';

// Configura la base de la URL y otras configuraciones
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_URL_API; // URL base de tu API

const API_URL = process.env.REACT_APP_URL_API;
// console.log('API_URL :>> ', API_URL);

// Variable para controlar si ya se redirigió a /login
let hasRedirectedToLogin = false;

// Configura el interceptor de respuesta de Axios para manejar errores 401
axios.interceptors.response.use(
  (response) => {
    return response;  // Si la respuesta es exitosa, simplemente la retornamos
  },
  (error) => {
    if (error.response && error.response.status === 401) {  // Verifica si la respuesta tiene un código de estado 401
      const currentUrl = window.location.href;
      const loginUrl = process.env.REACT_APP_URL+'login';

      if (!hasRedirectedToLogin && currentUrl !== loginUrl) {
        toast.error('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.', {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });

        hasRedirectedToLogin = true;

        // Redirige al usuario a la URL completa de login
        window.location.href = loginUrl;
      }

      return Promise.resolve({ data: null });
    }

    return Promise.reject(error);  // Para otros errores, puedes seguir lanzando el error
  }
);






// Funciones de API

// Obtiene la lista de roles desde la API
export const getRoles = async () => {
  // Aquí se debería realizar una solicitud GET para obtener los roles
};

// Crea un nuevo rol en la API
export const createRole = async (roleData) => {
  // Aquí se debería realizar una solicitud POST para crear un nuevo rol
};

// Actualiza un rol existente en la API
export const updateRole = async (id, roleData) => {
  // Aquí se debería realizar una solicitud PUT para actualizar un rol existente
};

// Elimina un rol existente en la API
export const deleteRole = async (id) => {
  // Aquí se debería realizar una solicitud DELETE para eliminar un rol
};





/*

// Funciones de API
export const getRoles = async () => {
  const response = await axios.get(`${API_URL}roles`);
  return response.data || []; // Asegura que siempre se devuelva un array
};

export const createRole = async (roleData) => {
  const response = await axios.post(`${API_URL}roles`, roleData);
  return response.data || {};
};

export const updateRole = async (id, roleData) => {
  const response = await axios.put(`${API_URL}roles/${id}`, roleData);
  return response.data || {};
};

export const deleteRole = async (id) => {
  const response = await axios.delete(`${API_URL}roles/${id}`);
  return response.data || {};
};

*/

export const updateCarrera = async (id, formData) => {
  const response = await axios.post(`carrera/update/${id}`, formData);
  return response.data;
};

export const getCarreraById = async (id) => {
  const response = await axios.get(`${API_URL}carrera/${id}`);
  return response.data;
};






export const getApps = async () => {
  const response = await axios.get(`${API_URL}apps`);
  return response.data || [];
};

export const createApp = async (roleData) => {
  const response = await axios.post(`${API_URL}apps`, roleData);
  return response.data || {};
};

export const updateApp = async (id, roleData) => {
  const response = await axios.put(`${API_URL}apps/${id}`, roleData);
  return response.data || {};
};

export const deleteApp = async (id) => {
  const response = await axios.delete(`${API_URL}apps/${id}`);
  return response.data || {};
};


export const getPaginasData = async () => {
  const response = await axios.get(`${API_URL}pages/all`);
  return response.data || [];
};


export const getPaginas = async (page = 1) => {
  const response = await axios.get(`${API_URL}pages?page=${page}`);
  return response.data;
};


export const getPaginaById = async (id) => {
  const response = await axios.get(`${API_URL}pages/details/${id}`);
  return response.data;
};


export const createPagina = async (roleData) => {




  const response = await axios.post(`${API_URL}pages`, roleData);
  return response.data || {};
};




export const updatePagina = async (id, roleData22) => {
  try {
    // Agregar el id al cuerpo de la solicitud
    const dataToSend = new FormData();

    // Recorrer roleData22 y agregar todos los campos al FormData
    for (let pair of roleData22.entries()) {
      dataToSend.append(pair[0], pair[1]);
    }

    // Agregar el ID al cuerpo de la solicitud
    dataToSend.append('id', id);

    console.log("FormData que se enviará:");

    // Recorrer FormData y mostrar su contenido
    for (let pair of dataToSend.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    // Usar POST para actualizar la página
    const response = await axios.post(`${API_URL}pages/update/${id}`, dataToSend, {
      headers: {
        'Accept': 'application/json',
        // 'Content-Type': 'multipart/form-data' no es necesario con FormData
      }
    });

    return response.data || {};
  } catch (error) {
    console.error("❌ Error al actualizar la página", error);
    throw error;
  }
};







export const deletePagina = async (id) => {
  const response = await axios.delete(`${API_URL}pages/${id}`);
  return response.data || {};
};




export const getFunctionalities = async () => {
  const response = await axios.get(`${API_URL}functionalities`);
  return response.data || [];
};

export const createFunctionality = async (functionalityData) => {
  const response = await axios.post(`${API_URL}functionalities`, functionalityData);
  return response.data || {};
};

export const updateFunctionality = async (id, functionalityData) => {
  const response = await axios.put(`${API_URL}functionalities/${id}`, functionalityData);
  return response.data || {};
};

export const deleteFunctionality = async (id) => {
  const response = await axios.delete(`${API_URL}functionalities/${id}`);
  return response.data || {};
};

export const getUsersRoles = async () => {
  const response = await axios.get(`${API_URL}userroles`);
  return response.data || [];
};

export const createUserRoles = async (roleData) => {
  const response = await axios.post(`${API_URL}userroles`, roleData);
  return response.data || {};
};

export const updateUserRoles = async (id, roleData) => {
  const response = await axios.put(`${API_URL}userroles/${id}`, roleData);
  return response.data || {};
};

export const deleteUserRoles = async (id) => {
  const response = await axios.delete(`${API_URL}userroles/${id}`);
  return response.data || {};
};

export const getRolesForUser = async (id) => {
  const response = await axios.get(`${API_URL}userroles/${id}`);
  return response.data || [];
};

// Nueva función para obtener todos los usuarios sin paginación
export const getAllUsers = async () => {
  try {
    const response = await axios.get(`${API_URL}users/all`);
    // console.log('API response for all users:', response.data);
    const users = Array.isArray(response.data) ? response.data : response.data?.users || [];
    return users;
  } catch (error) {
    console.error('Error fetching all users:', error);
    return []; // Retorna un array vacío en caso de error
  }
};



export const getUsers = async ({ search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}users`, {
      params: { search, page, limit }
    });
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages: response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit)
    };
  } catch (error) {
    console.error('Error fetching users:', error);
    return { users: [], totalPages: 0 };
  }
};



// Funciones de API
export const getUser = async (id) => {
  const response = await axios.get(`${API_URL}users/${id}`);
  return response.data || {};
};

export const createUser = async (roleData) => {
  const response = await axios.post(`${API_URL}users`, roleData);
  return response.data || {};
};

export const updateUser = async (id, roleData) => {
  const response = await axios.put(`${API_URL}users/${id}`, roleData);
  return response.data || {};
};

export const deleteUser = async (id) => {
  const response = await axios.delete(`${API_URL}users/${id}`);
  return response.data || {};
};

export const getCodesFor = async (type) => {
  const response = await axios.get(`${API_URL}codesfor/${type}`);
  return response.data || [];
};







export const getAllUserAddresses = async ({userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}user_addresses/all/${userId}`, {
      params: { search, page, limit }
    });
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages: response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit)
    };
  } catch (error) {
    console.error('Error fetching users:', error);
    return { users: [], totalPages: 0 };
  }
};


/*

// Servicios para gestionar direcciones de usuario
export const getAllUserAddresses = async (userId) => {  // Id de usuario obtener su address

  // console.log("obtiene los address");
  const response = await axios.get(`${API_URL}user_addresses/all/${userId}`);
  return response.data || [];
};

*/








export const getUserAddresses = async (userId) => {   //  Id de address
  const response = await axios.get(`${API_URL}user_addresses/${userId}`);
  return response.data || [];
};

export const createUserAddress = async (userId, addressData) => {
  const response = await axios.post(`${API_URL}user_addresses`, addressData);
  return response.data || {};
};

export const updateUserAddress = async (addressId, addressData) => {
  const response = await axios.put(`${API_URL}user_addresses/id/${addressId}`, addressData);
  return response.data || {};
};

export const deleteUserAddress = async (addressId) => {
  const response = await axios.delete(`${API_URL}user_addresses/${addressId}`);
  return response.data || {};
};

export const deleteUserAddressId = async (addressId) => {
  const response = await axios.delete(`${API_URL}user_addresses/id/${addressId}`);
  return response.data || {};
};

export const getUserDocs = async (userId) => {
  const response = await axios.get(`${API_URL}user_docs/${userId}`);
  return response.data || [];
};

export const createUserDocs = async (userDocs) => {
  const response = await axios.post(`${API_URL}user_docs`, userDocs);
  return response.data || {};
};



export const updateUserDocsId = async (addressId, userDocs) => {
  const response = await axios.put(`${API_URL}user_docs/id/${addressId}`, userDocs);
  return response.data || {};
};

export const updateUserDocs = async (addressId, userDocs) => {
  const response = await axios.put(`${API_URL}user_docs/${addressId}`, userDocs);
  return response.data || {};
};

export const deleteUserDocs = async (addressId) => {
  const response = await axios.delete(`${API_URL}user_docs/${addressId}`);
  return response.data || {};
};

// Funciones de API
export const getCountries = async () => {
  const response = await axios.get(`${API_URL}countries`);
  return response.data || [];
};








// Apps


export const getAllUserApps = async ({userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}userapps/all/${userId}`, {
      params: { search, page, limit }
    });
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages: response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit)
    };
  } catch (error) {
    console.error('Error fetching users:', error);
    return { users: [], totalPages: 0 };
  }
};




export const getUserApp = async (userId) => {   //  Id de address
  const response = await axios.get(`${API_URL}userapps/${userId}`);
  return response.data || [];
};



export const createUserApp = async (userId, addressData) => {
  const response = await axios.post(`${API_URL}userapps`, addressData);
  return response.data || {};
};



export const updateUserApp = async (addressId, addressData) => {
  const response = await axios.put(`${API_URL}userapps/id/${addressId}`, addressData);
  return response.data || {};
};

/*
export const deleteUserApp = async (addressId) => {
  const response = await axios.delete(`${API_URL}user_addresses/${addressId}`);
  return response.data || {};
};

*/

export const deleteUserAppId = async (addressId) => {
  const response = await axios.delete(`${API_URL}userapps/id/${addressId}`);
  return response.data || {};
};














// Docs


export const getAllUserDocs = async ({userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}user_docs/all/${userId}`, {
      params: { search, page, limit }
    });
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages: response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit)
    };
  } catch (error) {
    console.error('Error fetching users:', error);
    return { users: [], totalPages: 0 };
  }
};


export const getUserDoc = async (userId) => {   //  Id de address
  const response = await axios.get(`${API_URL}user_docs/${userId}`);
  return response.data || [];
};



export const createUserDoc = async (userId, addressData) => {

// console.log(addressData,'addressDatazzzzz');

  const response = await axios.post(`${API_URL}user_docs`, addressData);
  return response.data || {};
};



export const updateUserDoc = async (addressId, addressData) => {
  const response = await axios.put(`${API_URL}user_docs/id/${addressId}`, addressData);
  return response.data || {};
};

/*
export const deleteUserDoc = async (addressId) => {
  const response = await axios.delete(`${API_URL}user_docs/${addressId}`);
  return response.data || {};
};

*/


export const deleteUserDocId = async (addressId) => {
  const response = await axios.delete(`${API_URL}user_docs/id/${addressId}`);
  return response.data || {};
};


// Roles







export const getRolesAllForUser = async ({userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}userroles/all/${userId}`, {
      params: { search, page, limit }
    });
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages: response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit)
    };
  } catch (error) {
    console.error('Error fetching users:', error);
    return { users: [], totalPages: 0 };
  }
};


export const getUserRole = async (userId) => {   //  Id de address
  const response = await axios.get(`${API_URL}userroles/${userId}`);
  return response.data || [];
};



export const createUserRole = async (userId, addressData) => {
  const response = await axios.post(`${API_URL}userroles`, addressData);
  return response.data || {};
};



export const updateUserRole = async (addressId, addressData) => {
  const response = await axios.put(`${API_URL}userroles/id/${addressId}`, addressData);
  return response.data || {};
};

/*
export const deleteUserRole = async (addressId) => {
  const response = await axios.delete(`${API_URL}user_addresses/${addressId}`);
  return response.data || {};
};

*/


export const deleteUserRoleId = async (addressId) => {
  const response = await axios.delete(`${API_URL}userroles/id/${addressId}`);
  return response.data || {};
};






// Funciones de API
export const getTipoCarreras = async () => {
  const response = await axios.get(`${API_URL}carrera/tipo`);
  return response.data || []; // Asegura que siempre se devuelva un array
};

// Funciones de API


/*

export const getCarreras = async () => {
  const response = await axios.get(`${API_URL}carrera`);
  return response.data || []; // Asegura que siempre se devuelva un array
};

*/





// Funciones de API

/*

export const getCarreras = async ({ tipo=null, estado=null, search=null, page = 1 }) => {
  const response = await axios.get(`${API_URL}carrera`, {
    params: { tipo, estado, search, page }
  });
  return response.data || [];
};

*/


export const getCarreras = async ({ tipo = null, estado = null, search = null, page = 1, limit = 50 }) => {
  const response = await axios.get(`${API_URL}carrera`, {
    params: { tipo, estado, search, page, limit }
  });
  return {
    carreras: response.data || [],
    totalPages: response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit),
  };
};





export const createCarrera = async (roleData) => {
  const response = await axios.post(`${API_URL}carrera`, roleData);
  return response.data || {};
};







/*

export const updateCarrera = async (id, roleData) => {
  const response = await axios.put(`${API_URL}carrera/${id}`, roleData, {
    headers: {
      'Content-Type': 'multipart/form-data'  // Asegura que el backend lo procese bien
    }
  });
  return response.data || {};
};

*/



export const deleteCarrera = async (id) => {
  const response = await axios.delete(`${API_URL}carrera/${id}`);
  return response.data || {};
};





export const getDocentes = async ({ search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}docentes`, {
      params: { search, page, limit }
    });
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages: response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit)
    };
  } catch (error) {
    console.error('Error fetching users:', error);
    return { users: [], totalPages: 0 };
  }
};


// Funciones de API

/*

export const getDocentes = async () => {
  const response = await axios.get(`${API_URL}docentes`);
  return response.data || []; // Asegura que siempre se devuelva un array
};

*/

export const createDocente = async (roleData) => {
  const response = await axios.post(`${API_URL}docentes`, roleData);
  return response.data || {};
};

export const updateDocente = async (id, roleData) => {
  const response = await axios.put(`${API_URL}docentes/${id}`, roleData);
  return response.data || {};
};

export const deleteDocente = async (id) => {
  const response = await axios.delete(`${API_URL}docentes/${id}`);
  return response.data || {};
};





// Funciones de API


export const getConvenios = async ({ search = '', page = 1, limit = 10, all = false }) => {
  try {
    const params = all ? { all: true } : { search, page, limit };
    const response = await axios.get(`${API_URL}convenios`, { params });

    console.log('🟢 API response.data:', response.data); // 👈 esto te dice la estructura real

    return {
      convenios: response.data?.convenios || response.data?.data || [],
      totalPages: all
        ? 1
        : response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit)
    };
  } catch (error) {
    console.error('🔴 Error fetching convenios:', error);
    return { convenios: [], totalPages: 0 };
  }
};






/*


export const getConvenios = async ({ search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}convenios`, {
      params: { search, page, limit }
    });
     console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages: response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit)
    };
  } catch (error) {
    console.error('Error fetching users:', error);
    return { users: [], totalPages: 0 };
  }
};


*/

/*


export const getConvenios = async () => {
  const response = await axios.get(`${API_URL}roles`);
  return response.data || []; // Asegura que siempre se devuelva un array
};

*/

export const createConvenio  = async (roleData) => {
  const response = await axios.post(`${API_URL}convenios`, roleData);
  return response.data || {};
};

/*
export const updateConvenio  = async (id, roleData) => {
  const response = await axios.put(`${API_URL}convenios/${id}`, roleData);
  return response.data || {};
};

*/

export const updateConvenio = async (id, roleData) => {
  const response = await axios.post(`${API_URL}convenios/${id}`, roleData, {
      headers: {
          'Content-Type': 'multipart/form-data', // Importante para archivos
          'X-HTTP-Method-Override': 'PUT', // Esto le dice a Laravel que trate la solicitud como PUT
      },
  });
  return response.data || {};
};

export const deleteConvenio  = async (id) => {
  const response = await axios.delete(`${API_URL}convenios/${id}`);
  return response.data || {};
};






// Funciones de API
export const getNovedades = async () => {
  const response = await axios.get(`${API_URL}novedades`);
  return response.data || []; // Asegura que siempre se devuelva un array
};

export const createNovedades  = async (roleData) => {
  const response = await axios.post(`${API_URL}novedades`, roleData);
  return response.data || {};
};

export const updateNovedades = async (id, roleData) => {
  const response = await axios.post(`${API_URL}novedades/${id}`, roleData, {
      headers: {
          'Content-Type': 'multipart/form-data', // Importante para archivos
          'X-HTTP-Method-Override': 'PUT', // Esto le dice a Laravel que trate la solicitud como PUT
      },
  });
  return response.data || {};
};

export const deleteNovedades  = async (id) => {
  const response = await axios.delete(`${API_URL}novedades/${id}`);
  return response.data || {};
};



export const getDepartments = async () => {
  const response = await axios.get(`${API_URL}departments`);
  return response.data || []; // Asegura que siempre se devuelva un array
};



// Funciones de API
export const getArchivos = async () => {
  const response = await axios.get(`${API_URL}novedades`);
  return response.data || []; // Asegura que siempre se devuelva un array
};

export const createArchivos  = async (roleData) => {
  const response = await axios.post(`${API_URL}novedades`, roleData);
  return response.data || {};
};

export const updateArchivos = async (id, roleData) => {
  const response = await axios.post(`${API_URL}novedades/${id}`, roleData, {
      headers: {
          'Content-Type': 'multipart/form-data', // Importante para archivos
          'X-HTTP-Method-Override': 'PUT', // Esto le dice a Laravel que trate la solicitud como PUT
      },
  });
  return response.data || {};
};

export const deleteArchivos  = async (id) => {
  const response = await axios.delete(`${API_URL}novedades/${id}`);
  return response.data || {};
};



export const getFolders = async () => {
  const response = await axios.get(`${API_URL}folders`);
  return response.data;
};

/*

export const uploadFolder = async (formData) => {
  await axios.post(`${API_URL}/upload-folder`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

*/

export const downloadFolderAsRar = async (folderId) => {
  const response = await axios.get(`${API_URL}/download-folder/${folderId}`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `folder_${folderId}.rar`);
  document.body.appendChild(link);
  link.click();
};



export const uploadFolder = async (files) => {
  const formData = new FormData();
  
  files.forEach(({ file, path }) => {
    const cleanPath = path.replace(file.name, ""); // Elimina el nombre del archivo de la ruta
    formData.append('files[]', file);
    formData.append('paths[]', cleanPath); // Solo la ruta de la carpeta
  });

  try {
    await axios.post(`${process.env.REACT_APP_URL_API}upload-folder`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("Archivos subidos con éxito");
  } catch (error) {
    console.error("Error al subir los archivos:", error);
  }
};




export const listFolders = async (path = '') => {
  try {
    const response = await axios.get(`${API_URL}list-folders`, {
      params: { path }, // Pasar el path como parámetro
    });
    return response.data; // Suponiendo que el backend devuelve un array con las carpetas y archivos
  } catch (error) {
    console.error("Error al obtener las carpetas:", error);
    return [];
  }
};


export const deleteItem = async (id) => {
  try {
    const response = await axios.delete(`${process.env.REACT_APP_URL_API}delete/${id}`);
    console.log(response.data.message || "Elemento eliminado con éxito");
    return true;
  } catch (error) {
    console.error("Error al eliminar el archivo/carpeta:", error.response?.data?.message || error);
    return false;
  }
};


 
export const createDownloadLink = async (path) => {
  console.log("Generando link para:", path);

  try {
    const response = await axios.post(`${process.env.REACT_APP_URL_API}create-download-link`, { path });

    if (!response.data.success) {
      console.error("Error en el backend:", response.data.message);
      return null;
    }

    return response.data.link || null;
  } catch (error) {
    console.error("Error al generar el link de descarga:", error.response?.data?.message || error);
    return null;
  }
};






export const getMediosdepagos = async ({ search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}mediosdepagos`, {
      params: { search, page, limit }
    });
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages: response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit)
    };
  } catch (error) {
    console.error('Error fetching users:', error);
    return { users: [], totalPages: 0 };
  }
};


// Funciones de API

/*

export const getMediosdepagos = async () => {
  const response = await axios.get(`${API_URL}mediosdepagos`);
  return response.data || []; // Asegura que siempre se devuelva un array
};

*/

export const createMediosdepago = async (roleData) => {
  const response = await axios.post(`${API_URL}mediosdepagos`, roleData);
  return response.data || {};
};

export const updateMediosdepago = async (id, roleData) => {
  const response = await axios.put(`${API_URL}mediosdepagos/${id}`, roleData);
  return response.data || {};
};

export const deleteMediosdepago = async (id) => {
  const response = await axios.delete(`${API_URL}mediosdepagos/${id}`);
  return response.data || {};
};





// ============================================================
// MENU
// ============================================================

export const getMenus = async (page = 1) => {
  try {
    const response = await axios.get(`${API_URL}menu?page=${page}`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo menú:", error);
    return {
      data: [],
      total: 0,
      last_page: 1
    };
  }
};


export const getMenuById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}menu/details/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo elemento del menú:", error);
    throw error;
  }
};


export const createMenu = async (menuData) => {
  try {
    const response = await axios.post(
      `${API_URL}menu`,
      menuData
    );

    return response.data || {};
  } catch (error) {
    console.error("Error creando elemento del menú:", error);
    throw error;
  }
};


export const updateMenu = async (id, menuData) => {
  try {
    const response = await axios.post(
      `${API_URL}menu/update/${id}`,
      menuData,
      {
        headers: {
          'Accept': 'application/json'
        }
      }
    );

    return response.data || {};
  } catch (error) {
    console.error("Error actualizando elemento del menú:", error);
    throw error;
  }
};


export const deleteMenu = async (id) => {
  try {
    const response = await axios.delete(
      `${API_URL}menu/${id}`
    );

    return response.data || {};
  } catch (error) {
    console.error("Error eliminando elemento del menú:", error);
    throw error;
  }
};






// ============================================================
// MENU - EDITOR VISUAL
// ============================================================

export const getAllMenus = async () => {
  try {

    const response = await axios.get(
      `${API_URL}menu/all`
    );

    return response.data;

  } catch (error) {

    console.error(
      "Error obteniendo todo el menú:",
      error
    );

    throw error;
  }
};


export const reorderMenus = async (items) => {
  try {

    const response = await axios.post(
      `${API_URL}menu/reorder`,
      {
        items
      }
    );

    return response.data;

  } catch (error) {

    console.error(
      "Error guardando orden del menú:",
      error
    );

    throw error;
  }
};
